<template>
  <v-container style="padding: 0px;">
      <v-row align="center" class="ml-2 mr-2">
        <v-col cols="12" align="center">
          <img
            placeholder="Senior"
            style="width: 120px; margin-right: 10px; margin-top: 10px;"
            src="@/assets/icone-senior-connect_colorido-solo.svg"
            class="mb-5 mr-3 pa-0"
          />

          <h1 class="light cabecalho" style="color: #009280" >Senior Connect</h1>
        </v-col>
      </v-row>
      <v-row align="center" >
        <v-col align="center">
          <h1>{{$t('home.welcome')}}</h1>
          <p>{{$t('home.version')}} : {{ latestVersion }}</p>
          <p><a href="https://documentacao.senior.com.br/#home.htm#plataforma" rel="noopener noreferrer" target="_blank">Portal de Documentacao XPlatform</a></p><p><a href="https://forumdeprodutos.senior.com.br/" rel="noopener noreferrer" target="_blank" style="background-color: rgb(255, 255, 255);">Forum de Produtos Senior</a></p><p><a href="https://ucsonline.senior.com.br" rel="noopener noreferrer" target="_blank">Universidade Corporativa Senior (UCS)</a></p><p><a href="https://youtu.be/7u1DKXk0hL4" rel="noopener noreferrer" target="_blank">Workshop - CONNECT: Primeiros passos</a></p><p><br></p>
      </v-col>
      </v-row>
      <v-row>
        <ProcessFeatures />
        <OthersFeatures />
      </v-row>
  </v-container>
</template>

<script>

import ProcessFeatures from './home/ProcessFeatures'
import OthersFeatures from './home/OthersFeatures'
import axios from 'axios'

export default {
  name: 'about',

  components: {
    ProcessFeatures,
    OthersFeatures
  },
  data: () => ({
    latestVersion: 'LOADING'
  }),
  created () {
    this.getLatestVersion()
  },
  methods: {
    getLatestVersion () {
      axios.create(
        {
          baseURL: 'https://seniorconnect.com.br:9010',
          paramsSerializer: (params) => new URLSearchParams(params)
        })
        .get('client/about').then(response => {
          this.latestVersion = response.data
          return response.data
        })
        .catch(error => {
          console.error(error)
          return 'CLOUD_CONN_ERROR'
        })
    }
  }

}
</script>
<style>
.cabecalho {
  margin-top: 45px;
  display: inline-block;
  vertical-align: top;
}

</style>
